import React, { useState, useEffect, useRef, useCallback } from "react";
import "../../App.css";
import { useApp } from '../../core/context';
import { INR, initials, today, uuid, invoiceStatus, dateInRange, logAudit, notify } from '../../core/helpers';
import { sb } from '../../core/db';
import { TASK_STATUSES, TASK_REQUIREMENT_TYPES, DEFAULT_DOC_TEMPLATES } from '../../core/constants';
import { Badge } from '../../components/Badge';
import { FilterBar } from '../../components/FilterBar';
import { IconProperties } from '../../icons.properties';
import { InlineIcon } from '../../components/Icon';
import { createAuthFor, syncAuthPassword } from '../../api';
import { generateTempPassword } from '../../core/helpers';


function EmployeesPage() {
  const { employees, clients, tasks, openModal, can } = useApp();
  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        {can("team_reports","create") && <button className="btn btn-primary" onClick={() => openModal("create-employee")}>+ Invite Employee</button>}
      </div>
      <div className="grid2">
        {employees.map(emp => {
          const empTasks   = tasks.filter(t => t.assignedTo === emp.id);
          const completed  = empTasks.filter(t => t.status === "completed").length;
          const pending    = empTasks.filter(t => t.status !== "completed" && t.status !== "cancelled").length;
          const empClients = clients.filter(c => c.assignedTo === emp.id);
          return (
            <div key={emp.id} className="card">
              <div className="card-body">
                <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 16 }}>
                  <div className="av av-lg" style={{ background: emp.color }}>{emp.avatar}</div>
                  <div>
                    <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                      <div style={{ fontSize: 16, fontWeight: 700 }}>{emp.name}</div>
                      <span style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:.5, padding:"2px 8px", borderRadius:5, background: emp.role==="admin"?"#FEF3C7":emp.role==="manager"?"#DBEAFE":"#DCFCE7", color: emp.role==="admin"?"#B45309":emp.role==="manager"?"#1E40AF":"#166534" }}>{emp.role}</span>
                    </div>
                    <div style={{ fontSize: 12, color: "var(--muted)" }}>{emp.email}</div>
                    <div style={{ fontSize: 12, color: "var(--muted)" }}>{emp.phone}</div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
                  {[["Clients", empClients.length, "var(--blue)"], ["Completed", completed, "var(--green)"], ["Pending", pending, "var(--orange)"]].map(([l, v, c]) => (
                    <div key={l} style={{ flex: 1, textAlign: "center", padding: "8px", borderRadius: 8, background: "#F9FAFB" }}>
                      <div style={{ fontSize: 18, fontWeight: 700, color: c }}>{v}</div>
                      <div style={{ fontSize: 10, color: "var(--muted)" }}>{l}</div>
                    </div>
                  ))}
                </div>
                <div style={{ fontSize: 12, fontWeight: 600, color: "var(--muted)", marginBottom: 6 }}>Assigned Clients</div>
                {empClients.map(c => (
                  <div key={c.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid #F3F4F6", fontSize: 12 }}>
                    <span>{c.name}</span>
                    <span style={{ color: "var(--muted)" }}>{c.progress}%</span>
                  </div>
                ))}
                <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
                  <button className="btn btn-sm" style={{ flex: 1, background: "var(--gold-lt)", color: "var(--gold-dk)", border: "1px solid var(--gold)" }}
                    onClick={() => openModal("edit-employee", { empId: emp.id })}><InlineIcon name="edit" size={14} gap={5}>Edit</InlineIcon></button>
                  <button className="btn btn-sm" style={{ flex: 1, background: "#FEF2F2", color: "var(--red)", border: "1px solid #FCA5A5" }}
                    onClick={() => openModal("reset-password", { userId: emp.id, email: emp.email, name: emp.name })}><InlineIcon name="lock" size={14} gap={5}>Reset Password</InlineIcon></button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════════════════════════════
// SETTINGS PAGES
// ═══════════════════════════════════════════════════════════════════════

export { EmployeesPage };
